// © Microsoft Corporation. All rights reserved.

export interface WindowsFlightConfig {
    markets?: string[];
    // not adding owner since that will be part of bundle, we can check file history to determine flight owner
}

export enum WindowsFlights {
    ShyHeader = "prg-shyheader",
    RemovePersonalizeBtn = "prg-1sw-remper",
    LocationEditor = "prg-loc-header",
    TopStoriesClickable = "prg-whltopsclick",
    SingleColumn = "prg-1sw-sincolwinhp",
    SingleColumnWea = "prg-1sw-sincolwea",
    SingleColumnT1 = "prg-sincolT1",
    SingleColumnT2 = "prg-sincolT2",
    ThreeColumn = "prg-1sw-hp3col",
    Clarity = "prg-1sw-clarity",
    OpenInNewTab = "prg-hp-acnewtab",
    VerticalBranding1 = "prg-vertbrand1",
    SWFeedCacheOff = "prg-1sw-dssw"
}

export function getFlightConfig(): { [key in WindowsFlights]?: WindowsFlightConfig } {
    // exposing as a function for unit testing purposes
    return flightConfig;
}

const flightConfig: { [key in WindowsFlights]?: WindowsFlightConfig } = {
    // add flight config here, example
    // [WindowsFlights.FlightName]: { markets: ["en-us", "en-gb"] }
    [WindowsFlights.LocationEditor]: { markets: ["en-us"] }
};